import { Component, OnInit } from '@angular/core';
import {FireService} from "../../fire.service";


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {

  quotes = [];

  constructor(private fireService: FireService) {
    fireService.getQuotes(items => this.quotes = items);
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// F:/Home/Locker/About-me/about-me1/src/app/displayer/home/home.component.ts